import { all, put, takeLatest } from 'redux-saga/effects';

import RestCLient from '~/modules/requests';

import {
  getItineraryPackages,
  getItineraryPackagesFailure,
  getItineraryPackagesSuccess,
} from '~/actions';

import { CONFIG } from '~/config';
import { ApiResponse, ItineraryPackage } from '~/types';

export function* getItineraryPackagesSaga() {
  try {
    const response: ApiResponse<ItineraryPackage[]> = yield RestCLient.get(
      `${CONFIG.env.apiBaseUrl}v2/packages/itinerary`,
    );

    if (response.status === 200) {
      yield put(getItineraryPackagesSuccess(response.data || []));
    }
  } catch (error: any) {
    yield put(getItineraryPackagesFailure({ errorMessage: error.message }));
  }
}

export default function* root() {
  yield all([
    takeLatest(getItineraryPackages.type, getItineraryPackagesSaga),
  ]);
}
